"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "תוך כמה זמן ניתן להשיג מטפל סיעודי בפתח תקווה?",
  answer: "אנו מתחייבים למתן מענה מהיר במיוחד עבור תושבי פתח תקווה והסביבה. ברוב המקרים, אנו מצליחים לאתר ולהציב מטפל סיעודי מקצועי בבית המטופל תוך פחות מ-5 שעות מרגע הפנייה. המטרה שלנו היא להעניק שקט נפשי מיידי למשפחה וטיפול מסור ליקירכם ללא המתנה מיותרת."
}, {
  question: "האם המטפלים שלכם מנוסים בעבודה עם קשישים בפתח תקווה?",
  answer: "בהחלט. כל המטפלים בצוות שלנו עוברים תהליך סינון קפדני והכשרות מקצועיות בתחום הסיעוד. אנו עובדים עם מטפלים בעלי ניסיון רב בטיפול במגוון מצבים רפואיים וקוגניטיביים, המכירים היטב את הצרכים הייחודיים של האוכלוסייה המבוגרת בפתח תקווה ומעניקים יחס אישי וחם."
}, {
  question: "מה כולל השירות של מטפל סיעודי פרטי בבית?",
  answer: "השירות מותאם אישית לצרכי המטופל וכולל סיוע בפעולות יומיומיות (ADL) כמו רחצה, הלבשה והאכלה, השגחה צמודה, ליווי לבדיקות רפואיות, ניהול תרופות ומתן תמיכה רגשית וחברתית. המטפל דואג לסביבה בטוחה ונקייה עבור המטופל בביתו בפתח תקווה."
}, {
  question: "האם ניתן לקבל שירות של מטפל סיעודי בפתח תקווה גם בסופי שבוע?",
  answer: "כן, אנו מבינים שצורך בסיעוד אינו מוגבל לימי חול. השירות שלנו זמין 24/7, כולל שבתות וחגים. מוקד החירום שלנו בפתח תקווה ערוך לתת מענה לכל פנייה דחופה בכל שעה, כדי להבטיח שהמטופל לעולם לא יישאר ללא השגחה מקצועית."
}, {
  question: "איך מתבצעת ההתאמה בין המטפל למטופל?",
  answer: "תהליך ההתאמה הוא קריטי להצלחת הטיפול. אנו בוחנים את המצב הרפואי, השפה המדוברת, העדפות אישיות ומיקום גיאוגרפי בפתח תקווה. אנו שואפים ליצור חיבור אנושי חזק מעבר להיבט המקצועי, כדי שהמטופל ירגיש בנוח ובביטחון מלא עם המטפל שנבחר עבורו."
}, {
  question: "האם אתם מסייעים בהגשת תביעות לביטוח לאומי או חברות ביטוח?",
  answer: "כחלק מהשירות המקיף שלנו בפתח תקווה, אנו מעמידים לרשותכם ייעוץ והכוונה בנוגע למיצוי זכויות סיעודיות. הצוות המקצועי שלנו יכול להדריך אתכם בתהליך הבירוקרטי מול המוסד לביטוח לאומי או חברות הביטוח הפרטיות כדי להקל עליכם ככל הניתן."
}, {
  question: "מה קורה אם המטפל אינו מתאים או שיש צורך להחליפו?",
  answer: "שביעות הרצון שלכם היא בראש סדר העדיפויות שלנו. אם מסיבה כלשהי הכימיה אינה עובדת או שיש צורך בשינוי, אנו נדאג להחלפת המטפל במהירות האפשרית. אנו מלווים את המשפחה לאורך כל הדרך ומוודאים שהטיפול בפתח תקווה מתבצע על הצד הטוב ביותר."
}];
export default function FaqAccordion() {
  return <section data-section-id="256979" id="שאלות-נפוצות-מטפל-סיעודי-בפתח-תקווה" className="bg-background py-16 md:py-24 text-foreground">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <p className="text-muted-foreground mb-3 text-sm font-semibold tracking-wider uppercase">
            כל המידע על שירותי סיעוד מקצועיים בפתח תקווה
          </p>
          <h2 className="text-foreground font-default text-3xl font-bold md:text-4xl">
            שאלות נפוצות - מטפל סיעודי בפתח תקווה
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border-border/50 rounded-lg border px-4 shadow-md sm:px-6">
              <AccordionTrigger className="text-foreground hover:no-underline py-5 text-right text-base font-default font-semibold [&>svg]:bg-accent [&>svg]:text-accent-foreground [&>svg]:box-content [&>svg]:h-4 [&>svg]:w-4 [&>svg]:rounded-lg [&>svg]:p-1.5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-5 text-base leading-relaxed font-sans">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}